import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock, FileText, CalendarCheck } from "lucide-react";

export function RestrictedArea() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // BYPASS AUTH FOR LOCAL PREVIEW
    setIsAuthenticated(true);
    setUsername("Admin (Anteprima)");
    setLoading(false);
    
    /* 
    const checkAuth = async () => {
      try {
        const response = await fetch("/api/check_auth.php");
        const data = await response.json();
        
        if (data.authenticated) {
          setIsAuthenticated(true);
          setUsername(data.username);
        } else {
          navigate("/login");
        }
      } catch (err) {
        console.error(err);
        // navigate("/login"); // Commented out for preview
        setIsAuthenticated(true); // Force true for preview
        setUsername("Admin (Anteprima)");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
    */
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await fetch("/api/logout.php");
      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  if (loading) return <div className="text-center py-20 text-brand-primary">Caricamento...</div>;

  if (!isAuthenticated) return null;

  const documents = [
    { name: "SCHEDE SICUREZZA", url: "#" }, // Da caricare
    { name: "CODICE ETICO", url: "/documenti/Sapio---Codice-Etico_2021.pdf" },
    { name: "MOG 231", url: "/documenti/Puglia-Life_MOG-231_.pdf" },
    { name: "D.Lgs. 231/2001", url: "#" }, // Da caricare
    { name: "ORGANISMO DI VIGILANZA", url: "#" }, // Da caricare
    { name: "ORGANIGRAMMA AZIENDALE", url: "#" }, // Da caricare
    { name: "MANUALE G.Q.A", url: "#" }, // Da caricare
    { name: "NUOVO REGOLAMENTO UE SULLA PRIVACY GDPR2016/679", url: "/documenti/Privacy.docx" },
    { name: "SEGNALAZIONI ILLECITI - WHISTLEBLOWING", url: "/documenti/WHISTLEBLOWING.docx" },
  ];

  return (
    <div className="container mx-auto px-4 py-12 min-h-[70vh]">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-4">
        <h1 className="text-3xl font-bold text-red-700 uppercase tracking-wider">Area Riservata</h1>
        <div className="flex items-center gap-4 text-sm">
          <span className="text-gray-600 font-medium">Ciao {username}</span>
          <Button onClick={handleLogout} variant="primary" size="sm" className="bg-brand-primary hover:bg-brand-secondary text-white">
            Logout
          </Button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-start">
        {/* Left Column: Document List */}
        <div className="space-y-4">
          <ul className="space-y-3">
            {documents.map((doc, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-gray-400 flex-shrink-0" />
                <a 
                  href={doc.url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-brand-primary font-medium uppercase text-sm tracking-wide transition-colors"
                >
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Column: Image and Action Buttons */}
        <div className="flex flex-col items-center space-y-8">
          {/* Lock Image Placeholder */}
          <div className="relative w-full max-w-md aspect-video bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg flex items-center justify-center shadow-inner overflow-hidden">
            <div className="absolute inset-0 opacity-10 bg-[url('/images/site/globe-pattern.png')] bg-cover bg-center" />
            <Lock className="w-24 h-24 text-brand-primary/20" />
            <div className="absolute inset-0 bg-gradient-to-t from-white/50 to-transparent" />
          </div>

          {/* Action Buttons */}
          <div className="w-full max-w-xs space-y-4">
            <Button asChild className="w-full h-12 text-lg bg-[#004080] hover:bg-[#003366] text-white shadow-lg">
              <a href="https://puglialifesrl.it/sistema-documenti/index.php" target="_blank" rel="noopener noreferrer">
                Gestione Documenti
              </a>
            </Button>
            
            <Button asChild className="w-full h-12 text-lg bg-[#004080] hover:bg-[#003366] text-white shadow-lg">
              <Link to="/area-riservata/permessi">
                RICHIESTA PERMESSI / FERIE
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
